/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import styles from "./styles";
import { Text } from "@react-pdf/renderer";

const HelmetPdfPage = (helmetData: any): any => {
  let htmlData: any = [];

  helmetData?.forEach((product: any) => {
    const productCustomizationJson = JSON.parse(product?.ProductCustomizationJson);

    htmlData = [
      ...htmlData,
      <Text key={product?.ConfigurationName} style={styles.productText}>
        {product?.ConfigurationName} (<Text style={styles.designIdColor}>{product?.DesignId}</Text>)
      </Text>,

      <Text key={product.SKU} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          SKU:
        </Text>{" "}
        {product.SKU}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Id:
        </Text>{" "}
        {product.DesignId}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Name:
        </Text>{" "}
        {product.ProductName}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Design Type:
        </Text>{" "}
        {product.DesignType}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Order Id:
        </Text>{" "}
        {productCustomizationJson?.OrderID}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Price:
        </Text>{" "}
        {productCustomizationJson?.PriceWithCurrency}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Filter:
        </Text>
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Sport:
        </Text>{" "}
        {productCustomizationJson?.filter["sport"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Faceguard:
        </Text>
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Model:
        </Text>{" "}
        {productCustomizationJson?.faceguard["model"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Area1:
        </Text>{" "}
      </Text>,

      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Finish:
        </Text>{" "}
        {productCustomizationJson?.faceguard["area1"]["finish"]}
      </Text>,
      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Color:
        </Text>{" "}
        {productCustomizationJson?.faceguard["area1"]["color"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Area2:
        </Text>{" "}
      </Text>,
      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Finish:
        </Text>{" "}
        {productCustomizationJson?.faceguard["area2"]["finish"]}
      </Text>,
      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Color:
        </Text>{" "}
        {productCustomizationJson?.faceguard["area2"]["color"]}
      </Text>,

      <Text key={""} style={styles.level1Spacing}>
        <Text key={""} style={styles.dataKey}>
          Helmet:
        </Text>
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Model:
        </Text>{" "}
        {productCustomizationJson?.helmet["model"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Size:
        </Text>{" "}
        {productCustomizationJson?.helmet["size"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Style:
        </Text>{" "}
        {productCustomizationJson?.helmet["style"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Area1:
        </Text>{" "}
      </Text>,

      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Finish:
        </Text>{" "}
        {productCustomizationJson?.helmet["area1"]["finish"]}
      </Text>,
      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Color:
        </Text>{" "}
        {productCustomizationJson?.helmet["area1"]["color"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Area2:
        </Text>{" "}
      </Text>,
      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Finish:
        </Text>{" "}
        {productCustomizationJson?.helmet["area2"]["finish"]}
      </Text>,
      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Color:
        </Text>{" "}
        {productCustomizationJson?.helmet["area2"]["color"]}
      </Text>,

      <Text key={""} style={styles.level2Spacing}>
        <Text key={""} style={styles.dataKey}>
          Area3:
        </Text>{" "}
      </Text>,
      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Finish:
        </Text>{" "}
        {productCustomizationJson?.helmet["area3"]["finish"]}
      </Text>,
      <Text key={""} style={styles.level3pacing}>
        <Text key={""} style={styles.dataKey}>
          Color:
        </Text>{" "}
        {productCustomizationJson?.helmet["area3"]["color"]}
      </Text>,
    ];
  });
  return htmlData;
};

export default HelmetPdfPage;
